import {Injectable} from '@angular/core';
import {RouterService} from '@npck/libs/commons';
import {TableEvent} from '../components/full-table/full-table.component';
import {IncidentDetailsTab, IncidentDetailsTabState} from '../pages/incidents/details/incident-details.component';
import {Path} from '../path';

@Injectable({providedIn: 'root'})
export class IncidentDetailsFilterHolderService {
    private stateByIncident: Record<string, Partial<Record<IncidentDetailsTab, IncidentDetailsTabState>>> = {};

    constructor(
        private routerService: RouterService,
    ) {
        this.routerService.navigationEnd()
            .subscribe(event => {
                if (!event.url.includes(Path.INCIDENTS)) {
                    this.clear();
                }
            });
    }

    getState(incidentId: string, tab: IncidentDetailsTab): IncidentDetailsTabState | undefined {
        return this.stateByIncident[incidentId]?.[tab];
    }

    storeTableState(incidentId: string, tab: IncidentDetailsTab, tableEvent: TableEvent): IncidentDetailsTabState {
        this.stateByIncident[incidentId] = this.stateByIncident[incidentId] ?? {};
        const newState: IncidentDetailsTabState = {
            tableEvent: {...tableEvent, filter: {...tableEvent.filter}},
        };
        this.stateByIncident[incidentId][tab] = newState;
        return newState;
    }

    clear(): void {
        this.stateByIncident = {};
    }
}
